export default __webpack_public_path__ + "static/media/default.232784d7f673fda228436f99d44de611.png";